
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSwitch, AppSelect, AppButton } from '@/components';
import { useGameMatchEdit } from '@/modules/game/match/model/edit';
import { GameMatchOptions, GameMatchType, GameMatchCostState } from '@/modules/game/match/model/mixins';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
export default defineComponent({
    name: ROUTE_NAME_GAME.MATCH.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppSwitch, AppSelect, AppButton },
    setup() {
        const { model, v$, actions } = useGameMatchEdit();

        return { model, v$, GameMatchOptions, GameMatchType, GameMatchCostState, actions };
    }
});
